
import React from "react";
import ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import theme from "./theme";
import { registerSW } from "virtual:pwa-register";
import "./locales/i18n";
import "./fonts.css";
import { Typography } from "@mui/material";
import { getAppName } from "./utils/commonMethods";
import { AppName } from "./utils/constants";

// Set document title from env
document.title = import.meta.env.VITE_APP_PROJECT_NAME || "Fauna Protect";

// Set favicon dynamically based on APP_NAME
const faviconMap: Record<AppName, string> = {
  [AppName.FaunaProtect]: "/favicon-fauna.ico",
  [AppName.BioEcologie]: "/favicon-bio.ico",
  [AppName.EcoAssist]: "/favicon_ecoAssist.ico",
  [AppName.FaunaBeheer]: "/favicon-faunaBeheer.ico",
  [AppName.FaunaViewer]: "/favicon_faunaViewer.ico",
};
const appName = getAppName();
const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
if (link) link.href = faviconMap[appName] ?? "/favicon-fauna.ico";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register the service worker generated by vite-plugin-pwa. In dev this is a
// no-op since devOptions.enabled is false in vite.config.ts.
registerSW({ immediate: true });
